import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  Box,
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  // List,
  // ListItem,
  // ListItemButton,
  // ListItemIcon,
  // ListItemText,
  // Paper,
  useTheme,
  Divider,
} from '@mui/material';
import {
  School,
  Work,
  Newspaper,
  Event,
  VideoLibrary,
  Business,
  MenuBook,
  EmojiEvents,
  Groups,
} from '@mui/icons-material';

interface ContentItem {
  id: string;
  title: string;
  headline: string;
  content: string;
  icon: React.ReactElement;
}

const hrContentData: ContentItem[] = [
  {
    id: 'learnings',
    title: 'HR Learnings & Certification',
    headline: 'Coming Soon: HR Learnings & Certifications',
    content: 'Explore a wide range of HR courses, certifications, and learning programs designed for professionals and students. Upskill yourself and stay ahead in the HR industry.',
    icon: <School />
  },
  {
    id: 'careers',
    title: 'HR Careers & Jobs',
    headline: 'Coming Soon: HR Careers & Jobs',
    content: 'Discover the latest HR opportunities across India. Apply for jobs, internships, or get noticed by top recruiters through our reverse job portal.',
    icon: <Work />
  },
  {
    id: 'news',
    title: 'HR News & Updates',
    headline: 'Coming Soon: HR News & Updates',
    content: 'Stay informed with the latest HR trends, labour law updates, corporate HR stories, and industry insights to make smarter career decisions.',
    icon: <Newspaper />
  },
  {
    id: 'events',
    title: 'HR Events & Promotion',
    headline: 'Coming Soon: HR Events & Promotions',
    content: 'Attend live webinars, workshops, and HR summits. Access special promotions, scholarships, and exclusive learning opportunities.',
    icon: <Event />
  },
  {
    id: 'podcasts',
    title: 'Podcasts, Videos & Webinars',
    headline: 'Coming Soon: Podcasts, Videos & Webinars',
    content: 'Learn from top HR voices through expert interviews, case studies, tutorials, and on-demand video content.',
    icon: <VideoLibrary />
  },
  {
    id: 'services',
    title: 'HR Services & Expert Solutions',
    headline: 'Coming Soon: HR Services & Expert Solutions',
    content: 'Connect with HR consultants, trainers, and service providers. Book consultations, access HR tools, and get expert guidance for your organization.',
    icon: <Business />
  },
  {
    id: 'resources',
    title: 'HR Resources & Inspiration',
    headline: 'Coming Soon: HR Resources & Inspiration',
    content: 'Access downloadable HR templates, policies, guides, blogs, and success stories to enhance your skills and knowledge.',
    icon: <MenuBook />
  },
  {
    id: 'awards',
    title: 'Awards & Recognition',
    headline: 'Coming Soon: Awards & Recognition',
    content: 'Get recognized for your HR achievements. Earn badges, feature in leaderboards, and celebrate excellence in HR.',
    icon: <EmojiEvents />
  },
  {
    id: 'club',
    title: 'HRTalky Club',
    headline: 'Coming Soon: HRTalky Club',
    content: 'Join India\'s HR community. Network with peers, mentors, and experts, and access exclusive content, events, and mentorship programs.',
    icon: <Groups />
  }
];

export const HRContentPage: React.FC = () => {
  const theme = useTheme();
  const location = useLocation();
  // const navigate = useNavigate();
  const [selectedContent, setSelectedContent] = useState<string>('learnings');

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const section = urlParams.get('section');
    if (section && hrContentData.find(item => item.id === section)) {
      setSelectedContent(section);
    }
  }, [location.search]);

  const getCurrentContent = (): ContentItem | undefined => {
    return hrContentData.find(item => item.id === selectedContent);
  };

  // const isActive = (itemId: string) => selectedContent === itemId;

  // const handleMenuClick = (itemId: string) => {
  //   setSelectedContent(itemId);
  //   navigate(`/hr?section=${itemId}`);
  // };

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Grid container spacing={3}>
        {/* Sidebar Menu */}
        {/* <Grid size={{xs: 12, md: 4, lg: 3}}>
          <Paper
            elevation={0}
            sx={{
              border: `1px solid ${theme.palette.divider}`,
              borderRadius: 2,
              overflow: 'hidden',
            }}
          >
            <Box
              sx={{
                p: 3,
                background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
                color: 'white',
              }}
            >
              <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
                HR Hub
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                Your comprehensive HR resource center
              </Typography>
            </Box>
            
            <List sx={{ p: 0 }}>
              {hrContentData.map((item, index) => (
                <React.Fragment key={item.id}>
                  <ListItem disablePadding>
                    <ListItemButton
                      onClick={() => handleMenuClick(item.id)}
                      sx={{
                        py: 2,
                        px: 3,
                        bgcolor: isActive(item.id) ? 'primary.main' : 'transparent',
                        color: isActive(item.id) ? 'white' : 'text.primary',
                        '&:hover': {
                          bgcolor: isActive(item.id) ? 'primary.dark' : 'action.hover',
                        },
                        '& .MuiListItemIcon-root': {
                          color: isActive(item.id) ? 'white' : 'text.secondary',
                          minWidth: 40,
                        },
                      }}
                    >
                      <ListItemIcon>
                        {item.icon}
                      </ListItemIcon>
                      <ListItemText
                        primary={item.title}
                        slotProps={{
                          primary: {
                            sx: {
                              fontSize: '0.9rem',
                              fontWeight: isActive(item.id) ? 600 : 500,
                            }
                          }
                        }}
                      />
                    </ListItemButton>
                  </ListItem>
                  {index < hrContentData.length - 1 && (
                    <Divider sx={{ mx: 2 }} />
                  )}
                </React.Fragment>
              ))}
            </List>
          </Paper>
        </Grid> */}

        {/* Content Area */}
        <Grid size={{xs: 12, md: 12, lg: 12}}>
          {getCurrentContent() && (
            <Card
              elevation={0}
              sx={{
                border: `1px solid ${theme.palette.divider}`,
                borderRadius: 2,
                height: 'fit-content',
              }}
            >
              <CardContent sx={{ p: 4 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                  <Box
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      bgcolor: 'primary.main',
                      color: 'white',
                      mr: 3,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    {getCurrentContent()?.icon}
                  </Box>
                  <Box>
                    <Typography variant="h4" sx={{ fontWeight: 600, mb: 1 }}>
                      {getCurrentContent()?.headline}
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                      {getCurrentContent()?.title}
                    </Typography>
                  </Box>
                </Box>

                <Divider sx={{ mb: 3 }} />

                <Typography
                  variant="body1"
                  sx={{
                    lineHeight: 1.8,
                    fontSize: '1.1rem',
                    color: 'text.primary',
                  }}
                >
                  {getCurrentContent()?.content}
                </Typography>

                <Box
                  sx={{
                    mt: 4,
                    p: 3,
                    borderRadius: 2,
                    bgcolor: 'grey.50',
                    border: `1px solid ${theme.palette.divider}`,
                  }}
                >
                  <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                    What to Expect
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    This section is currently under development. We're working hard to bring you comprehensive HR resources and tools. 
                    Stay tuned for updates and exciting new features that will enhance your HR journey.
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          )}
        </Grid>
      </Grid>
    </Container>
  );
};